import { isSetSupported } from "@/office/requirements";

/**
 * Verfügbarkeit einzelner Office.js-Schnittstellen zur Laufzeit.
 *
 * Das Manifest verlangt nur WordApi 1.3, damit auch ältere Word-Versionen den
 * Kurs starten können. Einzelne Aufgaben brauchen aber neuere Schnittstellen.
 * Statt die Mindestanforderung anzuheben und Nutzer auszusperren, fragt jede
 * betroffene Prüfung hier nach und weicht sonst aus.
 */

/** Anforderungssätze, die in den Kursen geprüft werden. */
export const wordApi = {
  /** Felder im Dokument, z. B. Seitenzahlen. */
  fields: "1.4",
  /** Kommentare lesen. */
  comments: "1.4",
  /** Änderungsnachverfolgung ein-/ausschalten und auslesen. */
  changeTracking: "1.4",
  /** Definitionen der Formatvorlagen. */
  styles: "1.5",
  /** Fuß- und Endnoten. */
  notes: "1.5",
  /** Einzelne nachverfolgte Änderungen auslesen. */
  trackedChanges: "1.6",
  /** Hyperlinks eines Bereichs (`getHyperlinkRanges`). */
  hyperlinks: "1.3",
  /** Textmarken eines Bereichs (`getBookmarks`). */
  bookmarks: "1.4",
  /** Dokumenteigenschaften: Titel, Thema, Autor, Stichwörter, Vorlage. */
  properties: "1.3",
  /** Feldtyp (`Field.type`), z. B. "MergeField" oder "XE". */
  fieldTypes: "1.5",
} as const;

/** Anforderungssätze, die es nur in der Desktop-Version von Word gibt. */
export const wordApiDesktop = {
  /** Seitenränder, Ausrichtung und Papierformat. */
  pageSetup: "1.3",
  /** Textspalten, Zeilennummern, erste Seite anders, Seitenrahmen. */
  seitenDetails: "1.3",
  /** Kapitälchen, Großbuchstaben, Absatzrahmen und Schattierung. */
  zeichenDetails: "1.3",
  /** Sprache eines Textbereichs und automatische Silbentrennung. */
  sprache: "1.3",
  /** Frei positionierte Formen samt Textumbruch. */
  formen: "1.2",
  /**
   * Rechtschreib- und Grammatikfehler, Lesbarkeitsstatistik, Ansicht des
   * Fensters, VBA-Projekt und Dateiformat.
   */
  dokumentDetails: "1.4",
} as const;

export function supportsWordApi(version: string): boolean {
  return isSetSupported("WordApi", version);
}

/**
 * Nur in Word für Windows und Mac verfügbar – in Word im Web fehlen diese
 * Schnittstellen vollständig.
 */
export function supportsWordApiDesktop(version: string): boolean {
  return isSetSupported("WordApiDesktop", version);
}
